import type { Suggestion } from "react-places-autocomplete";

const POST_OFFICE_BOX_PATTERN =
  /\b(?:(?:p\.?\s*o\.?|post)\s*box|box|postfack)\b/i;

/** Place types that always point out one specific street address. */
const PRECISE_PLACE_TYPES = ["street_address", "premise", "subpremise"];

/** Place types that never point out one specific street address. */
const IMPRECISE_PLACE_TYPES = [
  "administrative_area_level_1",
  "administrative_area_level_2",
  "administrative_area_level_3",
  "country",
  "intersection",
  "locality",
  "neighborhood",
  "postal_code",
  "postal_town",
  "route",
  "sublocality",
];

export function hasStreetNumber(address: string): boolean {
  return !POST_OFFICE_BOX_PATTERN.test(address.trim()) && /\d/.test(address);
}

/**
 * Checks whether an autocomplete suggestion can resolve to a complete street
 * address, so suggestions that would fail address validation are never offered.
 */
export function isPreciseAddressSuggestion(suggestion: Suggestion): boolean {
  const types = suggestion.types ?? [];

  if (types.some((type) => PRECISE_PLACE_TYPES.includes(type))) {
    return true;
  }

  if (types.some((type) => IMPRECISE_PLACE_TYPES.includes(type))) {
    return false;
  }

  return hasStreetNumber(
    suggestion.formattedSuggestion?.mainText ?? suggestion.description,
  );
}
